import React, {useState} from 'react';
import { Form, InputGroup, FormControl, Row, Col, Card } from 'react-bootstrap';
import { Search } from 'lucide-react'; // Or any icon lib you're using

const Filters = ({ selectedStage, setSelectedStage, completionFilter, setCompletionFilter, uniqueStages }) => {

    const [searchTerm, setSearchTerm] = useState('');
  return (
    <Card className="mb-4 shadow-sm border-light">
      <Card.Body>
        <Row className="g-3">
          {/* Search Input */}
          <Col lg={6} xs={12}>
            <InputGroup>
              <InputGroup.Text>
                <Search size={16} className="text-muted" />
              </InputGroup.Text>
              <FormControl
                placeholder="Search projects or stages..."
                // as={text}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
          </Col>

          {/* Filters */}
          <Col lg={3} xs={6}>
            <Form.Select
              value={selectedStage}
              onChange={(e) => setSelectedStage(e.target.value)}
            >
              <option value="">All Stages</option>
              <option value="">Sales Phase</option>
              <option value="low">Design Phase</option>
              <option value="medium">Production Phase</option>
            </Form.Select>
          </Col>

          <Col lg={3} xs={6}>
            <Form.Select
              value={completionFilter}
              onChange={(e) => setCompletionFilter(e.target.value)}
            >
              <option value="">All Progress</option>
              <option value="low">Low (&lt; 30%)</option>
              <option value="medium">Medium (30-70%)</option>
              <option value="high">High (&gt; 70%)</option>
            </Form.Select>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Filters;
